module.exports = __webpack_public_path__ + "static/media/ELS100NG03.dc928f7a.png";